import EmployeeHighlight from './EmployeeHighlight';
export default EmployeeHighlight;